import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { SecureUploaderClientConfig } from './secure-uploader-client.config';
import { SecureUploaderService } from './services/secure-uploader.service';

@NgModule({
  imports: [CommonModule],
  providers: [SecureUploaderService, provideHttpClient(withInterceptorsFromDi())],
})
export class SecureUploaderClientModule {
  constructor(
    @Optional() @SkipSelf() parentModule: SecureUploaderClientModule,
    config: SecureUploaderClientConfig
  ) {
    // Check if NgModule was previously loaded
    // https://angular.io/guide/ngmodule-faq#how-can-i-tell-if-an-ngmodule-or-service-was-previously-loaded
    if (parentModule) {
      throw new Error(
        'SecureUploaderClientModule is already loaded. Import it in the AppModule only'
      );
    }

    if (!config) {
      throw new Error('Provide config for SecureUploaderClientModule using the forRoot method');
    }
  }

  static forRoot(
    config: SecureUploaderClientConfig
  ): ModuleWithProviders<SecureUploaderClientModule> {
    return {
      ngModule: SecureUploaderClientModule,
      providers: [
        {
          provide: SecureUploaderClientConfig,
          useValue: config,
        },
      ],
    };
  }
}
